import { ReactElement } from 'react'
import { Stack } from '@mui/material'
import { ChatModelOption } from '../modelAnimals'
import ModelSelect from './ModelSelect'
import ThreadCostChip from './ThreadCostChip'
import ThreadMenu from './ThreadMenu'

interface Props {
  projectId: string
  threadId: string
  isRunning: boolean
  /** A chat upload is running (see ThreadMenu). */
  isUploading: boolean
  models: ChatModelOption[]
  selectedModel: string | undefined
  onModelChange: (model: string) => void
  onSelectThread: (threadId: string, threadModel: string | null | undefined) => void
  onNewThread: () => void
}

/** Cost, model and thread controls of the chat's header. */
const ChatHeaderActions = ({
  projectId,
  threadId,
  isRunning,
  isUploading,
  models,
  selectedModel,
  onModelChange,
  onSelectThread,
  onNewThread,
}: Props): ReactElement => (
  <Stack direction="row" alignItems="center" spacing={1}>
    <ThreadCostChip key={threadId} threadId={threadId} isRunning={isRunning} />
    <ModelSelect models={models} value={selectedModel} onChange={onModelChange} />
    <ThreadMenu
      projectId={projectId}
      activeThreadId={threadId}
      disabled={isRunning || isUploading}
      onSelectThread={onSelectThread}
      onNewThread={onNewThread}
    />
  </Stack>
)

export default ChatHeaderActions
